export default __webpack_public_path__ + "static/media/p1-1.4d502aaa.png";